(function(){
  'use strict';
  var root=document.querySelector('.vlx');if(!root)return;
  var signin=new URLSearchParams(location.search).get('mode')==='signin';
  document.body.classList.add('velvt-afterhours');
  if(signin){root.classList.add('vlx--signin');return;}
  var card=root.querySelector('[data-velvt-auth-card]');if(!card)return;
  var dialog=document.createElement('dialog');dialog.className='vlx-auth';dialog.setAttribute('aria-label','Join Velvt');
  var close=document.createElement('button');close.type='button';close.className='vlx-auth-close';close.textContent='×';close.setAttribute('aria-label','Close signup');
  dialog.append(close,card);root.append(dialog);root.classList.add('vlx--ready');
  var trigger=null;
  function open(e){if(e)e.preventDefault();trigger=document.activeElement;if(!dialog.open)dialog.showModal();var input=card.querySelector('input:not([type=hidden]):not([disabled])');if(input)input.focus();}
  function dismiss(){dialog.close();}
  close.onclick=dismiss;
  dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dismiss();}});
  dialog.addEventListener('close',function(){if(trigger&&trigger.isConnected)trigger.focus();});
  root.querySelectorAll('a[href="#join"],[data-vlx-join]').forEach(function(a){a.addEventListener('click',open);});
  if(location.hash==='#join')open();
})();
